//todos: replace all hardcoded string with a global constants
export const LOCAL_STORAGE_ACCESS_TOKEN = 'token';
export const LOCAL_STORAGE_TOKEN_EXPIRY = 'frythub_TExpiry';
export const LOCAL_STORAGE_REFRESH_TOKEN = 'refresh_token';
export const LOCAL_STORAGE_USER_TYPE = 'user_type';
export const LOCAL_STORAGE_KYC_VALUE = 'vague';
export const LOCAL_STORAGE_USER_DATA = 'frythub_userD';

//Cookie keys
export const KYC_STATUS_COOKIE = 'KYC_STATUS_COOKIE';
export const USER_ROLE_COOKIE = 'USER_ROLE_COOKIE';
export const IS_STRIPE_COOKIE = 'IS_STRIPE_COOKIE';
export const ACCOUNT_TYPE_COOKIE = 'ACCOUNT_TYPE_COOKIE';
export const ATK_COOKIE = 'ATK_COOKIE';

export const userType = {
  agent: 'Agent',
  shipping: 'Shipping',
  User: 'User',
};
export enum USER_TYPE_ENUM {
  user = 1,
  deliveryAgent = 2,
  buyingAgent = 3,
  shippingAgent = 4,
}

export enum KycStatusType {
  NOT_CAPTURED = '1',
  DENIED = '2',
  PROCESSING = '3',
  APPROVED = '4',
}
export enum AgentAccountType {
  DELIVERY = '1',
  BUYING_DELIVERY = '2',
}

export const cloudinaryBaseUrl = ({
  cloudName,
  apiKey,
  timeStamp,
  signature,
}: {
  cloudName: string;
  apiKey: string;
  timeStamp: string;
  signature: string;
}) =>
  `https://api.cloudinary.com/v1_1/${cloudName}/auto/upload?api_key=${apiKey}&timestamp=${timeStamp}&signature=${signature}`;

//API SERVICE FOR CORE
export const apiBaseUrl =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_DEVBASE
    : process.env.NEXT_PUBLIC_PRODBASE;

//API SERVICE FOR NOTIFICATION
export const notificationApiBaseUrl =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_PROD_NOTIFICATION
    : process.env.NEXT_PUBLIC_PROD_NOTIFICATION;

//Freshwork api Base
export const freshWorkApiBaseUrl =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_FRESHWORK_API_BASE_PROD
    : process.env.NEXT_PUBLIC_FRESHWORK_API_BASE_PROD;

export const freshWorkToken =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_FRESHWORK_TOKEN_PROD
    : process.env.NEXT_PUBLIC_FRESHWORK_TOKEN_PROD;

//cloudinary keys
export const cloudName =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_CLOUDINARY_PROD_NAME
    : process.env.NEXT_PUBLIC_CLOUDINARY_PROD_NAME;

export const apiKey =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_CLOUDINARY_PROD_APIKEY
    : process.env.NEXT_PUBLIC_CLOUDINARY_PROD_APIKEY;

export const apiSecret =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_CLOUDINARY_PROD_APISECRET
    : process.env.NEXT_PUBLIC_CLOUDINARY_PROD_APISECRET;

//Sentry
export const sentryDSN =
  process.env.NODE_ENV === 'production'
    ? process.env.NEXT_PUBLIC_SENTRY_DSN
    : process.env.NEXT_PUBLIC_SENTRY_DSN;

//google keys
export const googleClientId =
  process.env.NODE_ENV === 'production'
    ? process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID
    : process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID;

export const googleMapKey =
  process.env.NODE_ENV === 'production'
    ? process.env.NEXT_PUBLIC_GOOGLE_MAP_API
    : process.env.NEXT_PUBLIC_GOOGLE_MAP_API;
